// src/components/modal/DeleteUploadModal.js

import React from 'react';
import { Link, Typography } from '@mui/material';
import { useCustomTheme } from '../../contexts/ThemeContext';
import CustomModal from '../universal/modals/CustomModal';
import { TermsOfServiceContent } from '../../helpers/TermsOfService';

interface TermsModalProps {
    closeModal: (resetForm?: () => void) => void; // Updated to match the definition
    isModalOpen: boolean;
    isMobile: boolean;
}

const TermsModal: React.FC<TermsModalProps> = ({
    isMobile,
    closeModal,
    isModalOpen,
}) => {
    const { theme } = useCustomTheme();
    return (
        <CustomModal
            isOpen={isModalOpen}
            onClose={() => closeModal()}
            isMobile={isMobile}
            cancelLabel={'Close'}
        >
            <TermsOfServiceContent />
        </CustomModal>
    );
};

export default TermsModal;
